import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getTranslationsAPI() {
  return serviceRequest(() => Service.translationControllerGetTranslations());
}
